import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const formTitle = css`
  display: block;
  font-size: 38px;
  line-height: 18px;
  padding-block: 19px;
  font-weight: 500;
  color: rgb(33, 32, 31);
`

export const verticals = css`
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-inline: -${spacing(2)};
`

export const wrapper = {
  formTitle: css`
    padding-block: ${spacing(1)};
  `,
  verticals: css`
    display: flex;
    gap: ${spacing(1)};
    overflow-y: visible;
    margin-block: ${spacing(2)};

    &::before,
    &::after {
      content: '';
      display: block;
      flex: 0 0 ${spacing(1)};
    }
  `,

  verticalItem: css`
    min-inline-size: ${spacing(19.75)};
    position: relative;
    display: flex;
  `,
}
